import { Badge } from "@/components/ui/badge";
import React from "react";
import { useTranslation } from "react-i18next";

export function StripeStatusRow({ status }: { status: string }) {
  const { t } = useTranslation();
  const normalizedStatus = status.toUpperCase();
  const isConnected = ["ACTIVE", "COMPLETE", "ENABLED"].some((value) =>
    normalizedStatus.includes(value),
  );

  return (
    <div className="border-base-border flex items-center justify-between gap-3 rounded-lg border p-3">
      <span className="text-sm font-medium text-black/96">
        {t("billing.connectionStatus")}
      </span>
      <Badge variant={isConnected ? "verified" : "new_secondary"}>
        {status}
      </Badge>
    </div>
  );
}
